import { ComponentProps, FC } from 'react';
import classNames from 'classnames';

type ButtonVariant = 'primary' | 'secondary' | 'bare';

interface Props extends ComponentProps<'button'> {
  variant?: ButtonVariant;
}

const variantStyles: Record<ButtonVariant, string> = {
  primary:
    'px-6 py-4 leading-none font-medium border border-primary min-w-48 text-white bg-primary hover:border-primary-800 hover:bg-primary-800 disabled:text-medium-grey-600 disabled:bg-light-grey-600 disabled:border-transparent',
  secondary:
    'px-6 py-4 leading-none font-medium border border-primary min-w-48 text-primary hover:border-text-primary-800 hover:border-primary-800 hover:text-primary-800 disabled:text-medium-grey-600 disabled:border-medium-grey-600',
  bare: 'p-4 min-w-48 text-sorairo-blue border-medium-grey-300 font-medium',
};

export const Button: FC<Props> = ({ children, variant = 'primary', className, ...props }) => {
  return (
    <button {...props} className={getButtonClassName(variant, className)}>
      {children}
    </button>
  );
};

export function getButtonClassName(variant: ButtonVariant, className?: string) {
  return classNames(variantStyles[variant], className);
}
